import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../App';
import { toast } from 'sonner';
import { decryptId } from '../utils/urlEncryption';
import CreateSelectionStepper from './CreateSelectionStepper';

const EditSelection = ({ user, onLogout }) => {
  const { selectionId: encryptedSelectionId } = useParams();
  const navigate = useNavigate();
  
  // Decrypt the selection ID from URL
  const selectionId = decryptId(encryptedSelectionId);
  
  const [selectionData, setSelectionData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSelectionData();
  }, [selectionId]);

  const loadSelectionData = async () => {
    try {
      const res = await axiosInstance.get(`/selections/${selectionId}`);
      setSelectionData(res.data);
    } catch (err) {
      toast.error('Failed to load selection data');
      navigate('/selections');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-amber-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading selection...</p>
        </div>
      </div>
    );
  }

  if (!selectionData) {
    return null;
  }

  return (
    <CreateSelectionStepper 
      user={user} 
      onLogout={onLogout} 
      editMode={true}
      existingSelection={selectionData}
    />
  );
};

export default EditSelection;
